/* Rancher's Market — Stock-Up Cart (guided cart builder)
   Fetches the live catalog from /products.json, walks the shopper through six
   questions, fills a cart in whole-meal units, and hands off to /cart. */
(function () {
  'use strict';
  var root = document.getElementById('RmStockUpCart');
  if (!root) return;
  var app = root.querySelector('#suc-app');
  var toastEl = root.querySelector('#suc-toast');

  var CATS = [
    { id: 'beef', name: 'Beef' },
    { id: 'poultry', name: 'Poultry' },
    { id: 'pork', name: 'Pork' },
    { id: 'fish', name: 'Fish' },
    { id: 'shell', name: 'Shellfish' },
    { id: 'game', name: 'Lamb & Game' },
    { id: 'dairy', name: 'Eggs & Dairy' }
  ];
  var MEALS = [
    { id: 'b', name: 'Breakfast', lbs: 0.25, meta: 'about ¼ lb protein per person' },
    { id: 'l', name: 'Lunch', lbs: 0.35, meta: 'about ⅓ lb protein per person' },
    { id: 'd', name: 'Dinner', lbs: 0.5, meta: 'about ½ lb protein per person' }
  ];
  var RANGES = [
    { label: 'Under $50', min: 0, max: 50 },
    { label: '$50 – $100', min: 50, max: 100 },
    { label: '$100 – $200', min: 100, max: 200 },
    { label: '$200 – $300', min: 200, max: 300 },
    { label: '$300 – $400', min: 300, max: 400 },
    { label: '$400 – $500', min: 400, max: 500 },
    { label: '$500+', min: 500, max: Infinity }
  ];
  /* Non-core discovery items, by product handle. kinds: seasoning/pantry/broth/breakfast/treat */
  var RAIL_SPEC = [
    { handle: 'pluck-pure-shaker', kind: 'seasoning', cats: ['beef', 'pork', 'game'] },
    { handle: 'loisa-adobo', kind: 'seasoning', cats: ['poultry', 'pork'] },
    { handle: 'loisa-sazon', kind: 'seasoning', cats: ['poultry', 'pork'] },
    { handle: 'vera-salts-spring-salt-pepper-grinder', kind: 'seasoning', cats: ['beef', 'fish', 'game'] },
    { handle: 'oliva-dorado-olive-oil', kind: 'pantry', cats: ['beef', 'fish', 'shell'] },
    { handle: 'mesocano-heirloom-flour-tortillas-grass-fed-butter', kind: 'pantry', cats: [] },
    { handle: 'leavyned-sourdough-pasta', kind: 'pantry', cats: [] },
    { handle: 'simpli-regenerative-organic-certified-black-beans', kind: 'pantry', cats: [] },
    { handle: 'florida-grass-fed-finished-whole-new-york-strip-roast-fcym8-xlctf-amsk9-lwh6l-fjyb6-27kwd-f9g6y-arbh9-ac2tl-js5h9-yb3bw-llyc8-jfpy9-c28wy-7cjkj-3w9cd-9c7fg-7ff9k-gbyyn-wew6h', kind: 'broth', cats: ['beef'] },
    { handle: 'pasture-raised-chicken-bone-broth', kind: 'broth', cats: ['poultry'] },
    { handle: 'biofarm-grassfed-provision-raw-honey-wild-flower', kind: 'breakfast', cats: [] },
    { handle: 'purity-coffee-balance-12oz-ground', kind: 'breakfast', cats: [] },
    { handle: 'alday-cows-milk-butter-8oz', kind: 'breakfast', cats: [] },
    { handle: 'raw-vanilla-ice-cream-16oz', kind: 'treat', cats: [] }
  ];

  /* ---------- catalog curation (mirrors the prototype's rules) ---------- */
  var RE_SKIP = /(whole cow|half cow|quarter cow|eighth of a cow|package|caviar|fortify|tallow|suet|marrow|knuckle|feet|gizzard|heart|tongue|suckling|gator|pre-?\s?order|bitter apricot)/i;
  var RE_SWAP_ONLY = /(liver|ox\s?tail|wagyu)/i;
  var RE_SHELLFISH = /(shrimp|scallop|lobster|crab|oyster|clam)/i;
  var RE_BREAKFAST = /(bacon|sausage patty|maple|eggs|yogurt|breakfast)/i;
  var RE_LUNCHY = /(ground|stew|kabob|sausage|burger|dogs|thighs|drumstick|wings|tenderloin|deli)/i;
  var RE_STAPLE = /(ground|stew|eggs|bacon|thighs|wings|drumstick|kabob)/i;
  var NO_FILL_TAG = 'no-stock-up';

  function parseLbs(t) {
    if (!t || /default title/i.test(t)) return null;
    t = String(t).toLowerCase().replace(/\s*lbs?\b/g, '').trim();
    var m = t.match(/^(\d*\.?\d+)\s*oz$/); if (m) return +m[1] / 16;
    m = t.match(/^(\d*\.?\d+)\s*-\s*(\d*\.?\d+)$/); if (m) return (+m[1] + +m[2]) / 2;
    m = t.match(/^(\d*\.?\d+)$/); if (m) return +m[1];
    return null;
  }
  function titleLbs(title) {
    var t = title.toLowerCase();
    if (t.indexOf('12 eggs') > -1) return 1.5;
    var m = t.match(/(\d+)\s*oz/); if (m) return +m[1] / 16;
    if (t.indexOf('pint') > -1) return 1;
    if (t.indexOf('quart') > -1) return 2;
    if (t.indexOf('1 lb') > -1) return 1;
    return 1;
  }
  function cleanName(t) {
    t = t.replace('Florida Grass-Fed & Finished ', '').replace(' - Pasture Raised', '').replace('- Pasture Raised', '');
    t = t.replace(/\s*-\s*Wild Caught.*$/i, '');
    t = t.replace(/\s*\(.*grass-fed.*\)$/i, '');
    t = t.replace(/,?\s*(Corn & Soy Free|Soy & Corn-Free|Grain-Free & Soy-Free)/g, '');
    return t.replace(/\s+/g, ' ').trim().replace(/^-+|-+$/g, '').trim();
  }
  function catOf(p) {
    var pt = p.product_type;
    if (pt === 'Beef') return 'beef';
    if (pt === 'Poultry') return 'poultry';
    if (pt === 'Pork') return 'pork';
    if (pt === 'Seafood') return RE_SHELLFISH.test(p.title) ? 'shell' : 'fish';
    if (pt === 'Lamb' || pt === 'Exotic Meat') return 'game';
    if (pt === 'Eggs' || pt === 'Cheese') return 'dairy';
    if (pt === 'Raw Dairy') return /yogurt|cheese/i.test(p.title) ? 'dairy' : null;
    return null;
  }
  function curate(raw) {
    var items = [], extras = [], byHandle = {};
    raw.forEach(function (p) { byHandle[p.handle] = p; });
    raw.forEach(function (p) {
      var cat = catOf(p);
      if (!cat || RE_SKIP.test(p.title)) return;
      if ((p.tags || []).some(function (t) { return String(t).toLowerCase() === NO_FILL_TAG; })) return;
      var avail = (p.variants || []).filter(function (v) { return v.available; });
      if (!avail.length) return;
      var best = null, bestLbs = null;
      avail.forEach(function (v) {
        var lbs = parseLbs(v.title);
        if (lbs === null || lbs < 0.15 || lbs > 12) return;
        if (best === null || Math.abs(lbs - 1.25) < Math.abs(bestLbs - 1.25)) { best = v; bestLbs = lbs; }
      });
      if (!best) { best = avail[0]; bestLbs = titleLbs(p.title); }
      var price = parseFloat(best.price);
      if (!(bestLbs > 0) || price > 200) return;
      var meals;
      if (RE_BREAKFAST.test(p.title)) meals = /sausage link/i.test(p.title) ? 'bld' : 'b';
      else if (cat === 'dairy') meals = 'bl';
      else if (RE_LUNCHY.test(p.title)) meals = 'ld';
      else meals = 'd';
      items.push({
        id: String(best.id), handle: p.handle, cat: cat, name: cleanName(p.title),
        lbs: Math.round(bestLbs * 100) / 100, price: Math.round(price * 100) / 100,
        fill: !RE_SWAP_ONLY.test(p.title) && price <= 90, meals: meals,
        staple: RE_STAPLE.test(p.title),
        img: p.images && p.images.length ? p.images[0].src : null
      });
    });
    RAIL_SPEC.forEach(function (spec) {
      var p = byHandle[spec.handle];
      if (!p) return;
      var avail = (p.variants || []).filter(function (v) { return v.available; });
      if (!avail.length) return;
      extras.push({
        id: String(avail[0].id), name: cleanName(p.title), price: parseFloat(avail[0].price),
        kind: spec.kind, cats: spec.cats,
        img: p.images && p.images.length ? p.images[0].src : null
      });
    });
    return { items: items, extras: extras };
  }

  /* ---------- helpers ---------- */
  var PRODUCTS = [], EXTRAS = [];
  var S = {
    step: 'intro', people: 2, days: 7, meals: new Set(['d']),
    must: new Set(), avoid: new Set(), pins: new Set(),
    rangeIdx: null, cart: [], extras: new Set(), expanded: new Set(), swapOpen: null
  };
  function fmt(n) { return '$' + n.toFixed(2); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  var toastT;
  function toast(msg) {
    toastEl.textContent = msg; toastEl.classList.add('suc-show');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('suc-show'); }, 3200);
  }
  function track(ev, props) {
    try { if (window.posthog && window.posthog.capture) window.posthog.capture(ev, props || {}); } catch (e) { }
  }
  function imgUrl(src, w) {
    if (!src) return null;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function thumbHTML(p, cls) {
    cls = cls || 'suc-thumb';
    return p.img
      ? '<img class="' + cls + '" src="' + esc(imgUrl(p.img, 180)) + '" alt="" loading="lazy">'
      : '<span class="' + cls + ' suc-ph" aria-hidden="true">RM</span>';
  }
  var ICON_SWAP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M23 4v6h-6"/><path d="M1 20v-6h6"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/><path d="M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>';
  var ICON_TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2"/><path d="M19 6l-1 14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>';

  /* ---------- math ---------- */
  function allowedCats() { return CATS.filter(function (c) { return !S.avoid.has(c.id); }).map(function (c) { return c.id; }); }
  function mealOk(p) { return Array.from(S.meals).some(function (m) { return p.meals.indexOf(m) > -1; }); }
  function totalLbs() {
    var per = 0; S.meals.forEach(function (m) { per += MEALS.find(function (x) { return x.id === m; }).lbs; });
    return S.people * S.days * per;
  }
  function fillPool() { return PRODUCTS.filter(function (p) { return p.fill && allowedCats().indexOf(p.cat) > -1 && mealOk(p); }); }
  function catMedianPerLb(cat) {
    var ps = PRODUCTS.filter(function (p) { return p.fill && p.cat === cat; })
      .map(function (p) { return p.price / p.lbs; }).sort(function (a, b) { return a - b; });
    return ps.length ? ps[Math.floor(ps.length / 2)] : 15;
  }
  function blendedPerLb() {
    var cats = allowedCats(); if (!cats.length) return 15;
    var wsum = 0, acc = 0;
    cats.forEach(function (c) { var w = S.must.has(c) ? 2.5 : 1; acc += catMedianPerLb(c) * w; wsum += w; });
    return acc / wsum;
  }
  function floorPerLb() {
    var ps = fillPool(); if (!ps.length) return 8;
    return Math.min.apply(null, ps.map(function (p) { return p.price / p.lbs; }));
  }
  function suggested() { return totalLbs() * blendedPerLb(); }
  function floorCost() { return totalLbs() * floorPerLb(); }
  function suggestedRangeIdx() {
    var s = suggested();
    var i = RANGES.findIndex(function (r) { return s >= r.min && s < r.max; });
    return i === -1 ? RANGES.length - 1 : i;
  }
  function conflict() {
    if (S.rangeIdx === null) return false;
    var r = RANGES[S.rangeIdx];
    return r.max !== Infinity && r.max < floorCost();
  }

  /* ---------- fill algorithm: whole-meal units ---------- */
  function buildCart() {
    var r = RANGES[S.rangeIdx];
    var cap = (r.max === Infinity ? Math.max(suggested(), 500) : r.max) * 0.95;
    var need = totalLbs();
    var cats = allowedCats();
    var lines = new Map(); var spent = 0, filled = 0;
    function qtyOf(p) { var l = lines.get(p.id); return l ? l.qty : 0; }
    function addN(p, n) {
      var l = lines.get(p.id) || { p: p, qty: 0 };
      l.qty += n; lines.set(p.id, l); spent += p.price * n; filled += p.lbs * n;
    }
    var mainMeals = ['l', 'd'].filter(function (m) { return S.meals.has(m); });
    function mealLbsOf(m) { return S.people * MEALS.find(function (x) { return x.id === m; }).lbs; }
    var defSlotLbs = mainMeals.length ? mealLbsOf(mainMeals[mainMeals.length - 1]) : S.people * 0.25;
    function unit(p, lbs) { return Math.max(1, Math.ceil(lbs / p.lbs)); }
    var slotUse = {};
    function maxSlots(p) { return p.staple ? 3 : 2; }
    function useSlot(p) { slotUse[p.id] = (slotUse[p.id] || 0) + 1; }

    S.pins.forEach(function (id) {
      var p = PRODUCTS.find(function (x) { return x.id === id; });
      if (!p || cats.indexOf(p.cat) === -1) return;
      var n = unit(p, p.meals === 'b' ? S.people * 0.25 : defSlotLbs);
      if (spent + p.price * n <= cap) { addN(p, n); useSlot(p); }
    });

    var bLbs = S.meals.has('b') ? S.people * S.days * 0.25 : 0;
    var mainLbs = need - bLbs;
    var weights = {}, wsum = 0;
    cats.forEach(function (c) { var w = S.must.has(c) ? 2.5 : 1; weights[c] = w; wsum += w; });
    var target = {};
    cats.forEach(function (c) { target[c] = mainLbs * weights[c] / wsum; });
    lines.forEach(function (l) {
      if (target[l.p.cat] !== undefined) target[l.p.cat] = Math.max(0, target[l.p.cat] - l.p.lbs * l.qty);
    });
    var tierCap = (cap / need) * 1.8;

    var bRemain = bLbs, guard = 0;
    var bItems = fillPool().filter(function (p) { return p.meals.indexOf('b') > -1; });
    while (bRemain > 0.2 && guard++ < 40) {
      var bc = bItems.filter(function (p) {
        return spent + p.price <= cap && p.price / p.lbs <= tierCap && qtyOf(p) < (p.staple ? 4 : 2);
      });
      if (!bc.length) break;
      bc.sort(function (a, b) {
        return Math.abs(a.lbs - bRemain) - Math.abs(b.lbs - bRemain) || a.price / a.lbs - b.price / b.lbs;
      });
      addN(bc[0], 1); bRemain -= bc[0].lbs;
    }

    guard = 0; var mi = 0;
    var mainItems = fillPool().filter(function (p) { return p.meals !== 'b'; });
    var tierLb = cap / need;
    while (guard++ < 120 && mainMeals.length) {
      var meal = mainMeals[mi++ % mainMeals.length];
      var slotLbs = mealLbsOf(meal);
      var deficits = cats.map(function (c) { return { c: c, d: target[c] }; }).sort(function (a, b) { return b.d - a.d; });
      if (!deficits.length || deficits[0].d <= slotLbs * 0.3) break;
      var c = deficits[0].c;
      var cands = mainItems.filter(function (p) {
        if (p.cat !== c || p.meals.indexOf(meal) === -1) return false;
        var n = unit(p, slotLbs);
        return spent + p.price * n <= cap && p.price / p.lbs <= tierCap && (slotUse[p.id] || 0) < maxSlots(p);
      });
      if (!cands.length) { target[c] = 0; continue; }
      cands.sort(function (a, b) {
        var na = (slotUse[a.id] || 0) === 0 ? 0 : 1, nb = (slotUse[b.id] || 0) === 0 ? 0 : 1;
        if (na !== nb) return na - nb;
        var oa = Math.floor((unit(a, slotLbs) * a.lbs - slotLbs) / (slotLbs * 0.4)),
          ob = Math.floor((unit(b, slotLbs) * b.lbs - slotLbs) / (slotLbs * 0.4));
        if (oa !== ob) return oa - ob;
        return Math.abs(a.price / a.lbs - tierLb) - Math.abs(b.price / b.lbs - tierLb);
      });
      var p2 = cands[0], n2 = unit(p2, slotLbs);
      addN(p2, n2); useSlot(p2);
      target[c] = Math.max(0, target[c] - n2 * p2.lbs);
    }

    guard = 0;
    function topN(p) { return unit(p, p.meals === 'b' ? S.people * 0.25 : defSlotLbs); }
    while (guard++ < 120) {
      var remaining = cap - spent;
      var tc = fillPool().filter(function (p) {
        return p.price * topN(p) <= remaining && (slotUse[p.id] || 0) < maxSlots(p) + 1;
      });
      if (!tc.length) break;
      tc.sort(function (a, b) {
        var na = qtyOf(a) === 0 ? 1 : 0, nb = qtyOf(b) === 0 ? 1 : 0;
        if (na !== nb) return nb - na;
        var ma = S.must.has(a.cat) ? 1 : 0, mb = S.must.has(b.cat) ? 1 : 0;
        if (ma !== mb) return mb - ma;
        return remaining > cap * 0.25
          ? (b.price / b.lbs) - (a.price / a.lbs)
          : a.price * topN(a) - b.price * topN(b);
      });
      var p3 = tc[0]; addN(p3, topN(p3)); useSlot(p3);
    }

    S.cart = Array.from(lines.values());
    return { spent: spent, filled: filled, need: need, cap: cap };
  }
  function cartSubtotal() {
    return S.cart.reduce(function (a, l) { return a + l.p.price * l.qty; }, 0) +
      Array.from(S.extras).reduce(function (a, id) {
        return a + EXTRAS.find(function (e) { return e.id === id; }).price;
      }, 0);
  }
  function cartLbs() { return S.cart.reduce(function (a, l) { return a + l.p.lbs * l.qty; }, 0); }
  /* cost per person per meal — the number that makes a big total feel fair */
  function perMeal(amount) {
    var denom = S.people * S.days * (S.meals.size || 1);
    return denom > 0 ? amount / denom : 0;
  }

  /* ---------- rendering ---------- */
  var STEPS = ['people', 'days', 'meals', 'must', 'avoid', 'budget'];
  /* animate only on step CHANGES — same-step re-renders (qty taps, chip toggles)
     must not replay the entrance animation or the page appears to flash */
  var lastStep = null;
  function screenCls(extra) {
    var animate = S.step !== lastStep; lastStep = S.step;
    return 'suc-screen' + (animate ? ' suc-anim' : '') + (extra ? ' ' + extra : '');
  }
  function go(step) { S.step = step; track('stock_up_step', { step: step }); render(); window.scrollTo({ top: root.offsetTop - 20 > 0 ? root.offsetTop - 80 : 0 }); }
  function progressHTML(step) {
    var i = STEPS.indexOf(step); if (i < 0) return '';
    return '<div class="suc-progress"><div class="suc-bar"><i class="suc-fill" style="width:' + ((i + 1) / STEPS.length * 100) + '%"></i></div>' +
      '<span class="suc-count">' + (i + 1) + ' of ' + STEPS.length + '</span></div>';
  }
  function nav(nextLabel, nextFn, backStep, disabled) {
    return '<div class="suc-footer-nav">' +
      (backStep ? '<button class="suc-backbtn" aria-label="Back" data-go="' + backStep + '">←</button>' : '') +
      '<button class="suc-btn" id="suc-next" ' + (disabled ? 'disabled' : '') + ' data-act="' + nextFn + '">' + nextLabel + '</button></div>';
  }
  function catCount(id) { return PRODUCTS.filter(function (p) { return p.cat === id; }).length; }

  function render() {
    var step = S.step;
    if (step === 'loading') return renderLoading();
    if (step === 'error') return renderError();
    if (step === 'intro') return renderIntro();
    if (step === 'building') return renderBuilding();
    if (step === 'review') return renderReview();
    var body = '';
    if (step === 'people') {
      body = '<p class="suc-eyebrow">Your crew</p>' +
        '<h2 class="suc-q">How many people are you shopping for?</h2>' +
        '<p class="suc-sub">Everyone who’ll be eating from this haul.</p>' +
        '<div class="suc-stepper">' +
        '<button class="suc-stepbtn" ' + (S.people <= 1 ? 'disabled' : '') + ' data-delta="people:-1" aria-label="Fewer people">−</button>' +
        '<div><div class="suc-val suc-num">' + S.people + '</div><span class="suc-unit">' + (S.people === 1 ? 'person' : 'people') + '</span></div>' +
        '<button class="suc-stepbtn" ' + (S.people >= 10 ? 'disabled' : '') + ' data-delta="people:1" aria-label="More people">+</button>' +
        '</div>' + nav('Next', 'go:days', null, false);
    }
    if (step === 'days') {
      var label = S.days <= 3 ? 'a few days' : S.days <= 8 ? 'about a week' : 'a big stock-up';
      body = '<p class="suc-eyebrow">The stretch</p>' +
        '<h2 class="suc-q">How many days should this last?</h2>' +
        '<p class="suc-sub">We’ll size the cart so you’re covered — ' + label + '.</p>' +
        '<div class="suc-stepper">' +
        '<button class="suc-stepbtn" ' + (S.days <= 1 ? 'disabled' : '') + ' data-delta="days:-1" aria-label="Fewer days">−</button>' +
        '<div><div class="suc-val suc-num">' + S.days + '</div><span class="suc-unit">' + (S.days === 1 ? 'day' : 'days') + '</span></div>' +
        '<button class="suc-stepbtn" ' + (S.days >= 14 ? 'disabled' : '') + ' data-delta="days:1" aria-label="More days">+</button>' +
        '</div><div class="suc-hint-row">' +
        [3, 7, 14].map(function (d) {
          return '<button class="suc-hint-chip" aria-pressed="' + (S.days === d) + '" data-days="' + d + '">' +
            (d === 3 ? 'Few days' : d === 7 ? 'One week' : 'Two weeks') + '</button>';
        }).join('') + '</div>' + nav('Next', 'go:meals', 'people', false);
    }
    if (step === 'meals') {
      body = '<p class="suc-eyebrow">The table</p>' +
        '<h2 class="suc-q">Which meals are we covering?</h2>' +
        '<p class="suc-sub">Each day, for everyone. Pick all that apply.</p>' +
        '<div class="suc-grid">' + MEALS.map(function (m) {
          return '<button class="suc-chip suc-wide" aria-pressed="' + S.meals.has(m.id) + '" data-meal="' + m.id + '">' +
            '<span class="suc-name">' + m.name + '</span><span class="suc-meta">' + m.meta + '</span></button>';
        }).join('') + '</div>' + nav('Next', 'go:must', 'days', S.meals.size === 0);
    }
    if (step === 'must') {
      body = '<p class="suc-eyebrow">The good stuff</p>' +
        '<h2 class="suc-q">Anything that must make the cart?</h2>' +
        '<p class="suc-sub">Optional — tap a category to prioritize it, tap again to pin specific cuts.</p>' +
        '<div class="suc-grid">' + CATS.map(function (c) {
          var pinned = PRODUCTS.filter(function (p) { return p.cat === c.id && S.pins.has(p.id); }).length;
          return '<button class="suc-chip" aria-pressed="' + S.must.has(c.id) + '" data-must="' + c.id + '">' +
            '<span class="suc-name">' + c.name + '</span>' +
            '<span class="suc-meta">' + catCount(c.id) + ' items' + (pinned ? ' · ' + pinned + ' pinned' : '') + '</span></button>' +
            (S.expanded.has(c.id) ? expanderHTML(c.id) : '');
        }).join('') + '</div>' +
        nav(S.must.size || S.pins.size ? 'Next' : 'Skip — surprise me', 'go:avoid', 'meals', false);
    }
    if (step === 'avoid') {
      body = '<p class="suc-eyebrow">House rules</p>' +
        '<h2 class="suc-q">Anything we should leave out?</h2>' +
        '<p class="suc-sub">We won’t add these at all. Optional.</p>' +
        '<div class="suc-grid">' + CATS.map(function (c) {
          return '<button class="suc-chip suc-avoid" aria-pressed="' + S.avoid.has(c.id) + '" data-avoid="' + c.id + '">' +
            '<span class="suc-name">' + c.name + '</span>' +
            (S.must.has(c.id) ? '<span class="suc-meta">currently a must-have</span>' : '') + '</button>';
        }).join('') + '</div>' +
        nav(S.avoid.size ? 'Next' : 'Skip — we eat everything', 'budget', 'must', allowedCats().length === 0);
    }
    if (step === 'budget') {
      var sug = suggested(), sIdx = suggestedRangeIdx(), lbs = totalLbs(), conf = conflict();
      if (conf) track('stock_up_conflict', { people: S.people, days: S.days, range: RANGES[S.rangeIdx].label });
      body = '<p class="suc-eyebrow">The budget</p>' +
        '<h2 class="suc-q">Set your budget.</h2>' +
        '<p class="suc-sub">We’ll fill the cart up to it — more variety and bigger cuts as room allows.</p>' +
        '<div class="suc-suggest-card"><div class="suc-big suc-num">~' + fmt(sug) + '</div>' +
        '<div class="suc-why">Our estimate for ' + S.people + ' ' + (S.people === 1 ? 'person' : 'people') + ' × ' +
        S.days + ' ' + (S.days === 1 ? 'day' : 'days') + ' (' +
        Array.from(S.meals).map(function (m) { return MEALS.find(function (x) { return x.id === m; }).name.toLowerCase(); }).join(' + ') +
        ') — about <b class="suc-num">' + lbs.toFixed(1) + ' lbs</b> of protein.</div>' +
        '<div class="suc-permeal">≈ <b class="suc-num">' + fmt(perMeal(sug)) + '</b> per person, per meal</div></div>' +
        '<div class="suc-budget-list">' + RANGES.map(function (r, i) {
          return '<button class="suc-budget-opt" aria-pressed="' + (S.rangeIdx === i) + '" data-range="' + i + '">' +
            '<span class="suc-num">' + r.label + '</span>' + (i === sIdx ? '<span class="suc-tag">Suggested</span>' : '') + '</button>';
        }).join('') + '</div>' +
        (conf ? '<div class="suc-conflict"><p><b>That budget won’t stretch that far.</b> Feeding ' + S.people +
          ' for ' + S.days + ' days takes at least <b class="suc-num">' + fmt(floorCost()) +
          '</b> — even with our most affordable cuts.</p><div class="suc-fixes">' +
          '<button class="suc-fixbtn" data-range="' + sIdx + '">Use ~' + fmt(sug) + '</button>' +
          '<button class="suc-fixbtn" data-go="days">Fewer days</button>' +
          '<button class="suc-fixbtn" data-go="meals">Fewer meals</button></div></div>' : '') +
        nav('Build my cart', 'build', 'avoid', S.rangeIdx === null || conf);
    }
    app.innerHTML = '<div class="' + screenCls() + '">' + progressHTML(step) + body + '</div>';
  }
  function expanderHTML(catId) {
    return '<div class="suc-expander" data-stop="1">' +
      PRODUCTS.filter(function (p) { return p.cat === catId && p.fill; }).slice(0, 14).map(function (p) {
        return '<div class="suc-pin-row"><span class="suc-p">' + esc(p.name) + ' · <span class="suc-num">' + fmt(p.price) + '</span></span>' +
          '<button class="suc-pinbtn" aria-pressed="' + S.pins.has(p.id) + '" data-pin="' + p.id + '">' +
          (S.pins.has(p.id) ? 'Pinned' : 'Pin') + '</button></div>';
      }).join('') + '</div>';
  }
  function renderLoading() {
    app.innerHTML = '<div class="' + screenCls('suc-build-screen') + '"><div class="suc-ring" aria-hidden="true"></div>' +
      '<h2 class="suc-q" style="margin-top:1.8rem">Setting up the counter</h2>' +
      '<p class="suc-sub" style="margin:0 auto">Loading today’s cuts and prices.</p></div>';
  }
  function renderError() {
    app.innerHTML = '<div class="' + screenCls('suc-build-screen') + '">' +
      '<h2 class="suc-q">We couldn’t load the catalog.</h2>' +
      '<p class="suc-sub" style="margin:1rem auto 2rem">Give it another try, or browse the market the usual way.</p>' +
      '<div style="max-width:32rem;margin:0 auto"><button class="suc-btn" data-act="retry">Try again</button>' +
      '<a class="suc-linkish" style="width:100%;text-align:center" href="/collections/all">Browse the market</a></div></div>';
  }
  function renderIntro() {
    app.innerHTML = '<div class="' + screenCls('suc-intro-hero') + '">' +
      '<div class="suc-rule-mark"></div>' +
      '<h1 class="suc-h1">' + esc(root.dataset.heading || 'Skip the browsing. Keep the good stuff.') + '</h1>' +
      '<p class="suc-sub">' + esc(root.dataset.subtext || 'Answer six quick questions and we’ll load a cart sized to your table, your taste, and your budget. You edit it; you’re always the boss of it.') + '</p>' +
      '<div class="suc-promise">' +
      '<div class="suc-p-row"><span class="suc-dot">—</span><span><b>About a minute.</b> Big buttons, no typing.</span></div>' +
      '<div class="suc-p-row"><span class="suc-dot">—</span><span><b>Fully editable.</b> Swap any cut, change any quantity.</span></div>' +
      '<div class="suc-p-row"><span class="suc-dot">—</span><span><b>No surprises.</b> We fill to your budget, never past it.</span></div>' +
      '</div>' +
      '<button class="suc-btn" data-act="start">Build my cart in about a minute</button>' +
      '<div style="text-align:center"><a class="suc-linkish" href="/collections/all" data-optout="1">No thanks — I’ll browse the market</a></div>' +
      '</div>';
  }
  function renderBuilding() {
    app.innerHTML = '<div class="' + screenCls('suc-build-screen') + '"><div class="suc-ring" aria-hidden="true"></div>' +
      '<h2 class="suc-q" style="margin-top:1.8rem">Cutting your order</h2>' +
      '<p class="suc-sub" style="margin:0 auto">Portioning ' + totalLbs().toFixed(1) + ' lbs across the counter.</p></div>';
  }
  function renderReview() {
    var r = RANGES[S.rangeIdx], sub = cartSubtotal(),
      capMax = r.max === Infinity ? Math.max(suggested(), 500) : r.max;
    var pct = Math.min(100, sub / capMax * 100);
    var barCls = sub > capMax ? 'suc-over' : pct > 96 ? 'suc-warn' : '';
    var byCat = CATS.filter(function (c) { return S.cart.some(function (l) { return l.p.cat === c.id; }); });
    var catSet = new Set(S.cart.map(function (l) { return l.p.cat; }));
    var rail = EXTRAS.filter(function (e) {
      if (e.kind === 'breakfast') return S.meals.has('b');
      if (!e.cats.length) return true;
      return e.cats.some(function (c) { return catSet.has(c); });
    }).slice(0, 8);
    app.innerHTML = '<div class="' + screenCls() + '">' +
      '<div class="suc-totals"><div class="suc-row">' +
      '<span class="suc-cap">Your cart · <span class="suc-num">' + cartLbs().toFixed(1) + ' lbs</span> protein</span>' +
      '<span class="suc-amt suc-num">' + fmt(sub) + '</span></div>' +
      '<div class="suc-budget-bar ' + barCls + '"><i style="width:' + pct + '%"></i></div>' +
      '<div class="suc-bstat">' + (sub > capMax
        ? 'Over your ' + r.label + ' budget by <b class="suc-num">' + fmt(sub - capMax) + '</b> — remove or swap something.'
        : '<b class="suc-num">' + fmt(capMax - sub) + '</b> left in your ' + r.label + ' budget.') + '</div>' +
      '<div class="suc-permeal"><b class="suc-num">' + fmt(perMeal(sub)) + '</b> per person, per meal</div></div>' +
      (S.transferFail ? '<div class="suc-transfer-err">' +
        '<p><b>' + (S.transferFail.total - S.transferFail.failed.length) + ' of ' + S.transferFail.total +
        ' items made it into your cart.</b> These didn’t:</p><ul>' +
        S.transferFail.failed.map(function (f) {
          return '<li><b>' + esc(f.name) + '</b> — ' + esc(f.reason) + '</li>';
        }).join('') + '</ul>' +
        '<div class="suc-fixes"><a class="suc-fixbtn" href="/cart">View your cart</a>' +
        '<button class="suc-fixbtn" data-act="clearfail">Keep editing</button></div></div>' : '') +
      byCat.map(function (c) {
        return '<div class="suc-cat-head"><h3>' + c.name + '</h3><span class="suc-lbs suc-num">' +
          S.cart.filter(function (l) { return l.p.cat === c.id; })
            .reduce(function (a, l) { return a + l.p.lbs * l.qty; }, 0).toFixed(1) + ' lbs</span></div>' +
          S.cart.filter(function (l) { return l.p.cat === c.id; }).map(lineHTML).join('');
      }).join('') +
      '<div class="suc-rail-head"><h2 class="suc-q" style="font-size:2.2rem">Pairs well with your cart</h2></div>' +
      '<p class="suc-rail-sub">A little discovery — seasonings, pantry, and treats from around the market.</p>' +
      '<div class="suc-rail">' + rail.map(function (e) {
        return '<div class="suc-rail-card">' + thumbHTML(e, 'suc-rimg') +
          '<span class="suc-kind">' + e.kind + '</span><span class="suc-nm">' + esc(e.name) + '</span>' +
          '<span class="suc-pr suc-num">' + fmt(e.price) + '</span>' +
          '<button class="suc-addbtn" aria-pressed="' + S.extras.has(e.id) + '" data-extra="' + e.id + '">' +
          (S.extras.has(e.id) ? 'Added' : 'Add') + '</button></div>';
      }).join('') + '</div>' +
      '<div class="suc-footer-nav">' +
      '<button class="suc-backbtn" aria-label="Back — edit my answers" title="Edit my answers" data-go="budget">←</button>' +
      '<button class="suc-btn" data-act="checkout">Add to cart — ' + fmt(sub) + '</button></div>' +
      '<div style="display:flex;justify-content:center;gap:.4rem;align-items:center">' +
      '<button class="suc-linkish" data-go="budget">Edit my answers</button>' +
      '<span style="color:var(--suc-line-strong)">·</span>' +
      '<button class="suc-linkish" data-act="restart">Start over</button></div>' +
      '<p class="suc-note">Nothing is purchased yet — adding to cart takes you to your regular cart to check out.</p>' +
      '</div>';
  }
  function lineHTML(l) {
    var alts = PRODUCTS.filter(function (p) {
      return p.cat === l.p.cat && p.id !== l.p.id && !S.cart.some(function (x) { return x.p.id === p.id; });
    }).sort(function (a, b) { return Math.abs(a.price - l.p.price) - Math.abs(b.price - l.p.price); }).slice(0, 3);
    return '<div class="suc-line-item">' + thumbHTML(l.p) +
      '<div class="suc-info"><div class="suc-nm">' + esc(l.p.name) + '</div>' +
      '<div class="suc-wt suc-num">' + l.p.lbs + ' lb' + (l.p.lbs !== 1 ? 's' : '') + ' each · ' + fmt(l.p.price) + '</div>' +
      '<div class="suc-qty">' +
      '<button aria-label="Less" data-qty="' + l.p.id + ':-1">−</button>' +
      '<span class="suc-n suc-num">' + l.qty + '</span>' +
      '<button aria-label="More" data-qty="' + l.p.id + ':1">+</button></div></div>' +
      '<div class="suc-right"><div class="suc-price suc-num">' + fmt(l.p.price * l.qty) + '</div>' +
      '<div class="suc-icon-row">' +
      (alts.length ? '<button class="suc-icon-btn suc-swap" aria-label="Swap ' + esc(l.p.name) + '" title="Swap" aria-expanded="' +
        (S.swapOpen === l.p.id) + '" data-swapopen="' + l.p.id + '">' + ICON_SWAP + '</button>' : '') +
      '<button class="suc-icon-btn" aria-label="Remove ' + esc(l.p.name) + '" title="Remove" data-rm="' + l.p.id + '">' + ICON_TRASH + '</button>' +
      '</div></div></div>' +
      (S.swapOpen === l.p.id
        ? '<div class="suc-swap-sheet"><div class="suc-t">Swap ' + esc(l.p.name) + ' for</div>' +
        alts.map(function (a) {
          return '<button class="suc-swap-opt" data-doswap="' + l.p.id + ':' + a.id + '">' + thumbHTML(a) +
            '<span class="suc-sn">' + esc(a.name) + '</span><span class="suc-sp suc-num">' + fmt(a.price) + '</span></button>';
        }).join('') + '</div>'
        : '');
  }

  /* ---------- actions ---------- */
  function toggleMust(id) {
    if (S.must.has(id) && !S.expanded.has(id)) S.expanded.add(id);
    else if (S.must.has(id) && S.expanded.has(id)) { S.must.delete(id); S.expanded.delete(id); }
    else { S.must.add(id); S.avoid.delete(id); }
    render();
  }
  function togglePin(id) {
    if (S.pins.has(id)) S.pins.delete(id);
    else {
      S.pins.add(id);
      var p = PRODUCTS.find(function (x) { return x.id === id; });
      if (p) { S.must.add(p.cat); S.avoid.delete(p.cat); }
    }
    render();
  }
  function toggleAvoid(id) {
    if (S.avoid.has(id)) S.avoid.delete(id);
    else {
      S.avoid.add(id);
      if (S.must.has(id)) {
        S.must.delete(id);
        var nPins = PRODUCTS.filter(function (p) { return p.cat === id && S.pins.has(p.id); }).length;
        PRODUCTS.forEach(function (p) { if (p.cat === id) S.pins.delete(p.id); });
        var nm = CATS.find(function (c) { return c.id === id; }).name;
        toast(nm + ' removed from your must-haves' + (nPins ? ' (' + nPins + ' pinned item' + (nPins > 1 ? 's' : '') + ' unpinned)' : ''));
      }
    }
    render();
  }
  function startBuild() {
    S.extras.clear(); S.swapOpen = null; S.transferFail = null;
    var st = buildCart();
    track('stock_up_built', {
      people: S.people, days: S.days, meals: Array.from(S.meals).join(''),
      budget: RANGES[S.rangeIdx].label, spent: Math.round(st.spent), lines: S.cart.length
    });
    S.step = 'building'; render();
    var quick = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(function () { S.step = 'review'; render(); window.scrollTo({ top: 0 }); }, quick ? 50 : 900);
  }
  function restart() {
    S.step = 'intro'; S.must = new Set(); S.avoid = new Set(); S.pins = new Set();
    S.meals = new Set(['d']); S.rangeIdx = null; S.cart = []; S.extras = new Set();
    S.expanded = new Set(); S.swapOpen = null; S.people = 2; S.days = 7; S.transferFail = null;
    render();
  }
  var checkingOut = false;
  function nameOfVariant(id) {
    var l = S.cart.find(function (x) { return Number(x.p.id) === id; });
    if (l) return l.p.name;
    var e = EXTRAS.find(function (x) { return Number(x.id) === id; });
    return e ? e.name : 'Item ' + id;
  }
  function setCheckoutBtn(label, disabled) {
    var b = app.querySelector('[data-act="checkout"]');
    if (b) { b.textContent = label; b.disabled = !!disabled; }
  }
  function addSingle(item) {
    /* resolves to null on success, or a human-readable failure reason */
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      if (res.ok) return null;
      return res.json().then(
        function (err) { return err.description || err.message || ('HTTP ' + res.status); },
        function () { return 'HTTP ' + res.status; }
      );
    }, function () { return 'Network error'; });
  }
  function checkout() {
    if (checkingOut) return;
    checkingOut = true;
    S.transferFail = null;
    setCheckoutBtn('Adding to your cart…', true);
    var items = S.cart.map(function (l) { return { id: Number(l.p.id), quantity: l.qty }; })
      .concat(Array.from(S.extras).map(function (id) { return { id: Number(id), quantity: 1 }; }));
    track('stock_up_checkout', { subtotal: Math.round(cartSubtotal()), lines: items.length });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (res.ok) { window.location.href = '/cart'; return null; }
      /* The bulk endpoint rejects the whole request when any one line has a
         problem (sold out since page load, quantity above stock, …). Fall back
         to adding lines one at a time so everything addable still transfers,
         and collect exactly what failed and why. */
      return items.reduce(function (chain, item) {
        return chain.then(function (fails) {
          return addSingle(item).then(function (reason) {
            if (reason) fails.push({ id: item.id, name: nameOfVariant(item.id), reason: String(reason) });
            return fails;
          });
        });
      }, Promise.resolve([])).then(function (fails) {
        checkingOut = false;
        if (!fails.length) { window.location.href = '/cart'; return; }
        S.transferFail = { total: items.length, failed: fails };
        track('stock_up_transfer_error', {
          sent: items.length, failed: fails.length,
          detail: fails.map(function (f) { return f.name + ': ' + f.reason; }).join(' | ').slice(0, 500)
        });
        renderReview();
        var panel = app.querySelector('.suc-transfer-err');
        if (panel) panel.scrollIntoView({ block: 'center' });
      });
    }).catch(function () {
      checkingOut = false;
      setCheckoutBtn('Add to cart — ' + fmt(cartSubtotal()), false);
      toast('Connection problem — nothing was added. Please try again.');
    });
  }

  /* one delegated click handler for the whole widget */
  app.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-go],[data-act],[data-delta],[data-days],[data-meal],[data-must],[data-avoid],[data-pin],[data-range],[data-qty],[data-rm],[data-swapopen],[data-doswap],[data-extra],[data-optout]');
    if (!b || b.disabled) return;
    var d = b.dataset;
    if (d.optout) { track('stock_up_opt_out'); return; } /* link navigates on its own */
    if (d.pin) { ev.stopPropagation(); togglePin(d.pin); return; }
    if (d.go) { go(d.go); return; }
    if (d.act) {
      if (d.act.indexOf('go:') === 0) { go(d.act.slice(3)); return; }
      if (d.act === 'start') { track('stock_up_started'); go('people'); }
      else if (d.act === 'budget') { if (S.rangeIdx === null) S.rangeIdx = suggestedRangeIdx(); go('budget'); }
      else if (d.act === 'build') startBuild();
      else if (d.act === 'checkout') checkout();
      else if (d.act === 'restart') restart();
      else if (d.act === 'retry') init();
      else if (d.act === 'clearfail') { S.transferFail = null; renderReview(); }
      return;
    }
    if (d.delta) {
      var parts = d.delta.split(':');
      S[parts[0]] += Number(parts[1]); render(); return;
    }
    if (d.days) { S.days = Number(d.days); render(); return; }
    if (d.meal) { S.meals.has(d.meal) ? S.meals.delete(d.meal) : S.meals.add(d.meal); render(); return; }
    if (d.must) { toggleMust(d.must); return; }
    if (d.avoid) { toggleAvoid(d.avoid); return; }
    if (d.range !== undefined) { S.rangeIdx = Number(d.range); render(); return; }
    if (d.qty) {
      var q = d.qty.split(':');
      var l = S.cart.find(function (x) { return x.p.id === q[0]; });
      if (l) { l.qty += Number(q[1]); if (l.qty <= 0) S.cart = S.cart.filter(function (x) { return x !== l; }); }
      renderReview(); return;
    }
    if (d.rm) {
      S.cart = S.cart.filter(function (x) { return x.p.id !== d.rm; });
      toast('Removed'); renderReview(); return;
    }
    if (d.swapopen) { S.swapOpen = S.swapOpen === d.swapopen ? null : d.swapopen; renderReview(); return; }
    if (d.doswap) {
      var s = d.doswap.split(':');
      var line = S.cart.find(function (x) { return x.p.id === s[0]; });
      var np = PRODUCTS.find(function (p) { return p.id === s[1]; });
      if (line && np) { line.p = np; S.swapOpen = null; toast('Swapped in ' + np.name); }
      renderReview(); return;
    }
    if (d.extra) {
      S.extras.has(d.extra) ? S.extras.delete(d.extra) : S.extras.add(d.extra);
      renderReview(); return;
    }
  });

  /* Keep the sticky totals bar clear of Dawn's sticky header. The header hides on
     scroll-down and reappears on scroll-up, so we track where its bottom edge
     actually is right now (0 when it has slid away) instead of measuring once. */
  var headerEl = null, stTick = false;
  function setStickyTop() {
    if (!headerEl || !headerEl.isConnected) {
      headerEl = document.querySelector('sticky-header header') ||
        document.querySelector('sticky-header') ||
        document.querySelector('.section-header');
    }
    var b = headerEl ? headerEl.getBoundingClientRect().bottom : 0;
    root.style.setProperty('--suc-top', Math.max(0, Math.round(b)) + 'px');
  }
  var stSettle;
  function onScrollSt() {
    /* re-measure once more after scrolling stops, so we catch the end state of
       the header's hide/show transition (it keeps animating briefly after the
       last scroll event) */
    clearTimeout(stSettle); stSettle = setTimeout(setStickyTop, 250);
    if (stTick) return;
    stTick = true;
    requestAnimationFrame(function () { stTick = false; setStickyTop(); });
  }
  window.addEventListener('scroll', onScrollSt, { passive: true });

  /* ---------- bootstrap ---------- */
  function fetchCatalog() {
    var all = [];
    function page(n) {
      return fetch('/products.json?limit=250&page=' + n)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) {
          var ps = j.products || [];
          all = all.concat(ps);
          if (ps.length === 250 && n < 5) return page(n + 1);
          return all;
        });
    }
    return page(1);
  }
  function init() {
    S.step = 'loading'; render();
    fetchCatalog().then(function (raw) {
      var c = curate(raw);
      PRODUCTS = c.items; EXTRAS = c.extras;
      if (!PRODUCTS.length) throw new Error('empty catalog');
      S.step = 'intro'; render();
      track('stock_up_view', { products: PRODUCTS.length });
    }).catch(function (e) {
      S.step = 'error'; render();
      track('stock_up_catalog_error', { message: String(e && e.message || e) });
    });
  }
  setStickyTop();
  window.addEventListener('resize', setStickyTop);
  init();
})();
